/*

Close On Esc mixin

Usage:
  import closeOnEsc mixin with path '@/mixins/close-on-esc'

*/

export default {
  created: function () {
    window.addEventListener('keydown', this.closeOnEsc)
  },
  destroyed: function () {
    window.removeEventListener('keydown', this.closeOnEsc)
  },
  methods: {
    closeOnEsc: function (e) {
      // 27 is the unique keycode of the esc key
      if (e.keyCode === 27 && this.active) {
        this.close()
      }
    }
  }
}
